import React, { Component } from "react";
import {
  DropdownV2,
  Loading,
  Button,
  Modal,
  Checkbox,
  // FormLabel
} from "carbon-components-react";
import { toast } from "react-toastify";
import { Breadcrumb } from "../../../../components";

import ExpandableCard from "../../../../components/ExpandableCard";
import {
  getByDmService,
  getDmService,
  updateDmService,
  insertDmService
} from "../../../../services/Api";
import appConfig from "../../../../config/app-config";
import { validarCPF}  from "../../../../lib/validations";
// import { isNull } from "lodash";

const { IMAGE_PATH } = appConfig;

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProfile: null,
      selectedSupervisor: null,
      email: "",
      cpf: "",
      password: "",
      confirmPassword: "",
      fotoBase64: "",
      nome: "",
      sobreNome: "",
      // supervisor: 1,
      // nivel: 10,
      supervisores: [],
      perfil: [],
      cadastradoEm: "",
      agencia: false,
      comunicacao: false,
      trade: false,
      cadastros: false,
      isFinished: false,
      hasPermissions: false,
      user: JSON.parse(localStorage.getItem("user")) || { nivel: {} },
      selecionados:[],
      equipes:[]
    };
  }

  componentWillMount = async () => {
    
    await this.getItems();
  };
  
  getItems = async () => {
    const { match } = this.props;
    try {
      this.getSupervisores();
      this.getPermissoes();
      this.getPermissoes()
      const data = await getByDmService("/Usuario", match.params.id);
      
      if (Number(match.params.id) === 0) {
        this.state.agencia = true;
        this.state.comunicacao = true;
        this.state.trade = true;
        this.state.cadastros = true;
      } 
      
      await this.setState({
        ...data,
        cadastradoEm: `Cadastrado em: ${data.dataCadastro}`,
        backgroundImage: IMAGE_PATH + data.foto,
        selectedProfile: { id: data.nivel.id, label: data.nivel.nome },
        selectedSupervisor: {
          id: (data.supervisor || { id: 0 }).id,
          label: (data.supervisor || { nome: "" }).nome
        },
        cpf: this.formatarCpf(data.cpf),
        hasPermissions: data.nivel && data.nivel.id > 0,
        selecionados:data.equipes || [],
      });
      await this.getEquipes();
    } catch (e) {
      if (match.params.id > 0)
        toast.error("Ocorreu um erro ao carregar os dados");
    }
  }

  getSupervisores() {
    getDmService("Usuario/GetSupervisores")
      .then(data => {
        const items = [];
        data.forEach(item => {
          items.push({ id: item.id, label: item.nome });
        });
        this.setState({ supervisores: items });
      })
      .catch(err => {
        console.log(err);
      });
  }


  getPermissoes = async () => {
    try {
      const data = await getDmService('/Usuario/GetNiveis');
      const perfil = await data.map(item => ({id: item.id, label: item.nome}));
      await this.setState({ perfil });
    } catch (error) {
      console.log(error);
    }
  }

  getEquipes = async () => {
    try {
      const equipes = await getDmService('/Equipe/GetAtivas');
      await this.setState({ equipes: equipes || [] });
    } catch (error) {
      console.log(error);
    }
  }


  onsubmit = e => {
    e.preventDefault();
    if (e.target.checkValidity()) this.save();
  };

  save = () => {
    const {
      email,
      password,
      confirmPassword,
      nome,
      sobreNome,
      cpf,
      fotoBase64,
      selectedProfile,
      selectedSupervisor,
      trade,
      cadastros,
      comunicacao,
      agencia,
      selecionados
    } = this.state;

    const formData = {
      email,
      password,
      confirmPassword,
      nome,
      sobreNome,
      cpf,
      fotoBase64,
      nivel: { id: (selectedProfile || { id: 50 }).id },
      supervisor: { id: (selectedSupervisor || { id: 0 }).id },
      // confirmPassword: password,
      fromAdmin: true,
      trade,
      cadastros,
      comunicacao,
      agencia,
      equipes:selecionados
    };
    this.setState({ isSaving: true });
    const { match, history } = this.props;
    const { id } = match.params;
    if (id && id > 0) {
      updateDmService("/Usuario", id, formData)
        .then(data => {
          this.setState({
            isSaving: false,
            hasPermissions: data && data.nivel > 0
          });
          toast.success("Dados atualizados com sucesso");
        })
        .catch(err => {
          this.handleCatch(err);
        });
    } else {
      insertDmService("/Usuario", formData)
        .then(data => {
          this.setState({
            isSaving: false,
            isFinished: true,
            hasPermissions: data.nivel && data.nivel.id > 0
          });
          toast.success("Usuário cadastrado com sucesso");
          history.push("/admin/usuarios/lista/novos");
        })
        .catch(err => {
          this.handleCatch(err);
        });
    }
  };

  handleCatch = err => {
    this.setState({ isSaving: false });
    if (typeof err.error.response.data.modelState !== "undefined") {
      let error = "Ocorreu o seguinte erro: ";

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace("model.", "");
        name = name[0].toUpperCase() + name.slice(1);
        error += `${name}: ${erros[p]}; `;
      }
      toast.error(error);
    } else {
      toast.error(
        "Ocorreu um erro ao salvar os dados, tente novamente mais tarde"
      );
    }
  };

  handleUploadFile = files => {
    const file = files[0];
    this.setState({ nomeArquivo: file.name });
    const reader = new FileReader();
    const self = this;
    reader.onloadend = () => {
      self.setState({
        backgroundImage: reader.result,
        fotoBase64: reader.result.replace(/data:image\/(png|jpeg);base64,/g, "")
      });
    };
    reader.readAsDataURL(file);
  };

  removeFile = () => {
    this.setState({
      backgroundImage: null,
      fotoBase64: null,
      nomeArquivo: null
    });
  };

  onChangeCheck = (val, id, event) => {
    this.setState({ [event.target.name]: val });
  };

  onChangeCheckEquipe = (e, element) => {
    const {selecionados} = this.state;
    let itens = selecionados;
    if(e) {
      itens.push(element)
    } else {
      itens = selecionados.filter(p=>p.id !== element.id);
    }
    console.log("itens", itens, element)
    this.setState({ selecionados: itens });
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeCPF = event => {
    this.setState({
      [event.target.name]: this.formatarCpf(event.target.value)
    });
    if (validarCPF(event.target.value)) event.target.setCustomValidity("");
    else event.target.setCustomValidity("O CPF informado é inválido.");
  };

  onChange = (item, change) => {
    if (change === "nivel") {
      this.setState({ selectedProfile: item.selectedItem });
    } else {
      this.setState({ selectedSupervisor: item.selectedItem });
    }
  };

  openModal = () => {
    // this.setState({ OpenCategory: true });
  };

  btnAction = () => {};

  toggleModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
      selectedId: null
    }));
  };

  onToggle = () => {};

  onRef = () => {};

  formatarCpf = inputCpf => {
    if(!inputCpf) return inputCpf;
    
    let cpf = inputCpf;
    if (cpf && cpf.length > 14) return cpf.slice(0, 14);
    cpf = cpf.replace(/\D/g, "");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return cpf;
  };

  renderRightBreadcrumb() {
    const { email, user, status } = this.state;
    const { match } = this.props;
    const isEdit = match.params.id > 0 && user.email !== email;
    const disableBLock = status && status.id === 2;
    const disableRelease = status &&  status.id === 1;

    if (isEdit) {
      return (
        <div className="breadcrumb-right-actions">
          <button
            type="button"
            className="bx--btn btn-primary-outlined v-md-margin"
            disabled={disableBLock}
            onClick={async () => {
              this.setState(
                {
                  modalHeading: "Bloquear Usuário",
                  primaryButtonText: "Confirmar",
                  modalMessage:
                    "Você tem certeza que deseja bloquear este usuário?"
                },
                () => {
                  this.toggleModal();
                }
              );

              this.btnAction = async () => {
                try {
                  await updateDmService(
                    "Usuario/AlteraStatus",
                    match.params.id,
                    {
                      status: 2
                    }
                  );
                  toast.success("Usuário atualizado com sucesso");
                  this.toggleModal();
                } catch (e) {
                  if (e.code !== 403)
                    toast.error("Não foi possível atualizar o usuário");
                }
              };
            }}
          >
            {" "}
            {disableBLock ? "Bloqueado " : "Bloquear "}
          </button>
          <button
            type="button"
            className="bx--btn btn-secondary-color v-md-margin"
            disabled={disableRelease}
            onClick={() => {
              this.setState(
                {
                  modalHeading: "Liberar Usuário",
                  primaryButtonText: "Confirmar",
                  modalMessage: "Deseja liberar este usuário?"
                },
                () => {
                  this.toggleModal();
                }
              );

              this.btnAction = async () => {
                try {
                  await updateDmService(
                    "Usuario/AlteraStatus",
                    match.params.id,
                    {
                      status: 1
                    }
                  );
                  await this.getItems()
                  await toast.success("Usuário atualizado com sucesso");                 
                  await this.toggleModal();
                } catch (e) {
                  if (e.code !== 403)
                    toast.error(
                      "Não foi possível atualizar os dados do usuário"
                    );
                }
              };
            }}
          >
            {disableRelease ? "Liberado" : "Liberar"}
          </button>
        </div>
      );
    }
    return null;
  }

  render() {
    const { match, history } = this.props;
    const isEdit = match.params.id > 0;

    const {
      selectedProfile,
      selectedSupervisor,
      email,
      password,
      confirmPassword,
      nome,
      sobreNome,
      supervisores,
      cpf,
      nomeArquivo,
      backgroundImage,
      isSaving,
      cadastradoEm,
      perfil,
      modalHeading,
      modalMessage,
      primaryButtonText,
      onRef,
      onToggle,
      isFinished,
      agencia,
      deleteModal,
      comunicacao,
      trade,
      cadastros,
      hasPermissions,
      selecionados,
      equipes
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title={isEdit ? `${nome} ${sobreNome || " "}` : "Cadastro"}
          description={isEdit ? cadastradoEm : "Novo usuário"}
          image={backgroundImage}
          renderLeft={(() => (
            <div
              className="breadcrumb-left-actions pointer"
              onClick={() => history.goBack()}
            >
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}
          renderRight={this.renderRightBreadcrumb()}
        />
        <section className="content-wrapper content-wrapper--large">
          <form id="form" onSubmit={this.onsubmit}>
            <ExpandableCard
              className="center-box"
              ref={onRef}
              title="Dados Pessoais"
              description={(() => (
                <div>
                  <strong>Nome: </strong> 
                  {`${nome} ${sobreNome || ""}`} 
                  <br />
                  <strong>E-mail: </strong> 
                  {email} 
                  <br />
                  <strong>CPF: </strong> 
                  {cpf} 
                  <br />
                  {selectedSupervisor ? (
                    <span>
                      <strong>Supervisor: </strong> 
                      {" "}
                      {(selectedSupervisor || { label: "" }).label} 
                      <br />
                    </span>

                  ) :
                  (
                    <span>{" "}</span>
                  )
                  }
                  
                 
                </div>
              ))()}
              expanded={!isEdit}
              onToggle={onToggle}
              leftComponent={() => (
                <div
                  className={`step-card-icon ${
                    isFinished || isEdit ? "step-card-icon--actived" : ""
                  }`}
                >
                  <i className="material-icons">
                    {!(isFinished || isEdit)
                      ? "check_circle_outline"
                      : "check_circle"}
                  </i>
                </div>
              )}
              rightComponent={() => (
                <div className="button h-sm-margin sm-padding">Editar</div>
              )}
            >
              <div className="mg-left-20">
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin foto-perfil">
                  <div
                    style={{ backgroundImage: `url('${backgroundImage}')` }}
                    className="img-cadastro"
                  />
                  <label className="bx--label">Minha foto</label>
                  <p>Arquivos jpg ou png de no máximo 500kb.</p>
                </div>
                <div className="bx--col-md-12">
                  <label className="bx--btn btn-secondary-outlined v-md-margin btn-white">
                    Adicionar arquivo
                    <div className="hide">
                      <input
                        type="file"
                        onChange={e => this.handleUploadFile(e.target.files)}
                      />
                    </div>
                  </label>
                </div>
                {nomeArquivo && (
                  <div className="bx--col-md-6">
                    <div className="file-upload">
                      <span>{nomeArquivo}</span>
                      <svg
                        onClick={() => this.removeFile()}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM4 7v2h8V7H4z" />
                      </svg>
                    </div>
                  </div>
                )}
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">Nome</label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="Nome"
                    name="nome"
                    value={nome}
                    onChange={this.onChangeText}
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">Sobrenome</label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="Sobrenome"
                    name="sobreNome"
                    value={sobreNome}
                    onChange={this.onChangeText}
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">CPF</label>
                  <input
                    type="text"
                    className="bx--text-input"
                    required
                    placeholder="CPF"
                    name="cpf"
                    value={cpf}
                    onChange={this.onChangeCPF}
                    pattern="\d{3}\.\d{3}\.\d{3}-\d{2}"
                    title="Digite um CPF válido"
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">Supervisor comercial</label>
                  <DropdownV2
                    label="Selecione o supervisor"
                    id="supervisor"
                    items={supervisores}
                    selectedItem={selectedSupervisor}
                    onChange={e => this.onChange(e, "supervisor")}
                  />
                </div>

                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">E-mail</label>
                  <input
                    type="email"
                    className="bx--text-input"
                    required
                    placeholder="E-mail"
                    name="email"
                    value={email}
                    onChange={this.onChangeText}
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">Senha</label>
                  <input
                    type="password"
                    className="bx--text-input"
                    required={!isEdit}
                    placeholder="Senha"
                    name="password"
                    value={password}
                    onChange={this.onChangeText}
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <label className="bx--label">Confirmar Senha</label>
                  <input
                    type="password"
                    className="bx--text-input"
                    required={!isEdit}
                    placeholder="confirme a senha"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
            </ExpandableCard>
            <ExpandableCard
              className="center-box"
              ref={onRef}
              title="Perfil e permissões"
              description={`Perfil: ${
                (selectedProfile || { label: "Interno" }).label
              }`}
              onToggle={onToggle}
              expanded={!hasPermissions}
              leftComponent={() => (
                <div
                  className={`step-card-icon ${
                    hasPermissions ? "step-card-icon--actived" : ""
                  }`}
                >
                  <i className="material-icons">
                    {!hasPermissions ? "check_circle_outline" : "check_circle"}
                  </i>
                </div>
              )}
              rightComponent={() => (
                <div className="button h-sm-margin sm-padding">Editar</div>
              )}
            >
              <div className="mg-left-20">
                <div className="bx--row mg-top-20 ">
                  <div className="bx--col-xs-11 bx--col-md-6 v-sm-margin">
                    <label htmlFor="nivel">Perfil de Permissões</label> 
                    <br />
                    {!(isFinished || isEdit)
                      ? <label className="description">"Se você não selecionar um perfil, o sistema atribuirá automaticamente o perfil 'Interno' como padrão."</label>
                      : ""}
                    
                    <br />
                    <label className="bx--label">Selecionar o perfil</label>
                    <DropdownV2
                      label="Interno"
                      id="nivel"
                      items={perfil}
                      initialSelectedItem={perfil[2]}
                      selectedItem={selectedProfile}
                      onChange={e => this.onChange(e, "nivel")}
                    />
                  </div>
                </div>
                {selectedProfile &&
                  (selectedProfile.id === 10 || selectedProfile.id === 50 ) && (
                    <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                      <Checkbox
                        name="agencia"
                        id="agencia"
                        defaultChecked={agencia}
                        className="v-lg-margin"
                        labelText="Agência e cadastros"
                        onChange={this.onChangeCheck}
                      />
                      <Checkbox
                        name="trade"
                        id="trade"
                        defaultChecked={trade}
                        className="v-lg-margin"
                        labelText="Trade e cadastros"
                        onChange={this.onChangeCheck}
                      />
                      <Checkbox
                        name="comunicacao"
                        id="comunicacao"
                        defaultChecked={comunicacao}
                        className="v-lg-margin"
                        labelText="Comunicação e cadastros"
                        onChange={this.onChangeCheck}
                      />
                      <Checkbox
                        name="cadastros"
                        id="cadastros"
                        defaultChecked={cadastros}
                        className="v-lg-margin"
                        labelText="Cadastros de usuário"
                        onChange={this.onChangeCheck}
                      />
                    </div>
                  )}
              </div>
            </ExpandableCard>
            <ExpandableCard
              className="center-box"
              ref={onRef}
              title="Equipes"
              description={`Equipes: ${(!selecionados || selecionados.length === 0) ? "N/I" : selecionados.map(p=>p.nome)}`}
              onToggle={onToggle}
              leftComponent={() => (
                <div className={`step-card-icon step-card-icon--actived"}`} />
              )}
              rightComponent={() => (
                <div className="button h-sm-margin sm-padding">Editar</div>
              )}
            >
              <div className="mg-left-20">
                {equipes && equipes.map(equipe=> (
                  <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                    <Checkbox
                      name="equipe"
                      id={`equipe${equipe.id}`}
                      checked={selecionados.map(p=>p.id).includes(equipe.id)}
                      className="v-lg-margin"
                      labelText={equipe.nome}
                      onChange={(e) => this.onChangeCheckEquipe(e, equipe)}
                    />
                  </div>
                  ))}
              </div>
            </ExpandableCard>
            <div className="bx--col-xs-12  v-md-margin">
              <Button
                kind="primary"
                className="bx--btn--full-width"
                type="submit"
              >
                Salvar
              </Button>
            </div>
          </form>
        </section>
        <Modal
          open={deleteModal}
          onRequestSubmit={this.btnAction}
          onRequestClose={this.toggleModal}
          modalHeading={modalHeading}
          primaryButtonText={primaryButtonText}
          secondaryButtonText="Cancelar"
        >
          <div className="warning-modal-txt">
            <p>{modalMessage}</p>
          </div>
        </Modal>
        {isSaving && <Loading small />}
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Users/Edit/Edit.jsx